import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { Bulletin, BulletinStatus } from "../types";

export const updateBulletinStatus = async (
  bulletinId: string,
  status: BulletinStatus,
) => {
  const collectionRef = collection(db, "bulletins");

  await updateDoc(doc(collectionRef, bulletinId), {
    status,
    publishedAt: status === BulletinStatus.Active ? new Date() : null,
  });

  const bulletinSnapshot = await getDoc(doc(collectionRef, bulletinId));

  return bulletinSnapshot.data() as Bulletin;
};
